import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-password-show",
  "use": "icon-password-show-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-password-show\"><path d=\"M8 4.5C5.4 4.5 2.2 5.9 1 8c1.2 2.1 4.4 3.5 7 3.5s5.8-1.4 7-3.5c-1.2-2.1-4.4-3.5-7-3.5M10.5 8c0 1.4-1.1 2.5-2.5 2.5S5.5 9.4 5.5 8 6.6 5.5 8 5.5s2.5 1.1 2.5 2.5M2.2 8c.6-.8 1.7-1.4 2.8-1.9-.3.5-.5 1.2-.5 1.9s.2 1.4.6 1.9C3.9 9.4 2.9 8.8 2.2 8m8.7 1.9c.4-.5.6-1.2.6-1.9s-.2-1.4-.6-1.9c1.2.5 2.2 1.1 2.9 1.9-.7.8-1.7 1.4-2.9 1.9\" /><circle cx=\"8\" cy=\"8\" r=\"1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol